(function($) {
    $.fn.jPaginate = function(options) {
        // If options is a string, treat it as a function call.
        if (typeof options === 'string') {
            let $selection = this;

            let functions = {
                'getCurrentPage': function() {
                    return $selection.data('jpConfig') ? $selection.data('jpConfig').page : null;
                },

                'getTotalPages': function() {
                    return $selection.data('jpConfig') ? $selection.data('jpConfig').totalPages : null;
                },

                'setCurrentPage': function(pageNumber) {
                    return showPage($selection, pageNumber);
                },
            };

            if (typeof functions[options] === 'function') {
                let args = Array.prototype.slice.call(arguments, [1]);
                return functions[options].apply(null, args)
            } else {
                throw options + " is not a function of jPaginate.";
            }
        }

        // Options is not a string.
        // Initialise jPaginate

        let defaults = {
            'max': 25, // The number of rows on each page.
            'max_navigation_pages': 10 // In the navigator, hide page numbers greater than this.
        };

        let parameters = $.extend(defaults, options);

        //We check the given values
        parameters.max = Math.max(1, parameters.max);
        parameters.page = Math.max(1, parameters.page);
        parameters.max_navigation_pages = Math.max(1, parameters.max_navigation_pages);

        return this.each(function() {
            let $table = $(this);

            if ($table.is('table')) {
                $table.data('jpConfig', parameters);

                let $container = getTableContainer($table);

                //Checking if the table was already paginated (re-paginating after sorting)
                let isPaginated = false;
                let $paginationControlsContainer = getPaginationControlsContainer($table);
                if ($paginationControlsContainer) {
                    isPaginated = true;
                } else {
                    $paginationControlsContainer = $("<div>").addClass("jPaginate-page_container");
                    $table.after($paginationControlsContainer);
                    $paginationControlsContainer = getPaginationControlsContainer($table);
                }

                //Removing old pagination
                if (isPaginated) {
                    $container.find('tr').removeClass(function() {
                        $(this).css("display", "none");
                        let toReturn = '',
                            classes = this.className.split(' ');
                        for (let i = 0; i < classes.length; i++ ) {
                            if (/jPaginate-row-\d{1,3}/.test(classes[i])) { /* Filters */
                                toReturn += classes[i] +' ';
                            }
                        }
                        return toReturn ;
                    });
                }

                //Determining number of pages
                let totalPages = 0;
                $container.find('tr').each(function(i) {
                    let $row = $(this);
                    if (i % parameters.max == 0) {
                        totalPages++;
                    }

                    //We add class to rows
                    $row.addClass('jPaginate-row-' + totalPages);
                    if (totalPages == parameters.page) {
                        $row.fadeIn("slow");
                    }
                });

                //We add the footer only if more than one page and no previous pagination
                if (totalPages > 1 && !isPaginated) {
                    //Pagination
                    let pageLinks = "";
                    for (let i = 1; i <= totalPages; i++) {
                        let style = '';
                        if (i > parameters.max_navigation_pages) {
                            style = 'display: none;';
                        }
                        pageLinks += '<li><a class="jPaginate-link-text jPaginate-link-text-' + i + ' ' + (i == parameters.page ? ' current' : '') + '" style="' + style + '" href="#">' + i + '</a></li>';
                    }

                    //Adding paginator
                    let links = '<ul class="pagination">';
                    links += '<li><a class="hide goto-first jPaginate-link-button" href="#"></a></li>';
                    links += '<li><a class="prevnext hide button-previous jPaginate-link-button" href="#">' + gettext("Previous") + '</a></li>';
                    links += pageLinks;
                    if (totalPages > 10) {
                        links += '<li class="dots"><span>...</span></li>';
                    }
                    $table.data("show-all", 1);
                    links += '<li><a data-cy="Paginate_Next" class="prevnext button-next jPaginate-link-button" href="#">' + gettext("Next") + '</a></li>';
                    links += '<li><a class="goto-last jPaginate-link-button" href="#"></a></li>';
                    links += ' | <li class="container-button-show-all"><a data-cy="All" class="button-show-all jPaginate-link-button" href="#">' + gettext("All") + '</a></li>';
                    links += '</ul>';
                    $paginationControlsContainer.html(links);

                    //Binding click event to pages (numbers)
                    $paginationControlsContainer.find('.jPaginate-link-text').click(function(e) {
                        e.preventDefault();
                        let requestedPage = $(this).hasClass("button-show-all") ? 0 : $(this).text();
                        showPage($table, requestedPage);
                    });

                    // Binding click event to buttons
                    $paginationControlsContainer.find('.jPaginate-link-button').click(function(e) {
                        e.preventDefault();

                        let parameters = $table.data('jpConfig');

                        let link = $(this);
                        let requestedPage = 0;
                        let currentPage = parameters.page;

                        if (link.hasClass("goto-first")) {
                            requestedPage = 1;
                        } else if (link.hasClass("button-previous")) {
                            requestedPage = currentPage - 1;
                        } else if (link.hasClass("button-next")) {
                            requestedPage = currentPage + 1;
                        } else if (link.hasClass("goto-last")) {
                            requestedPage = totalPages;
                        } else if (link.hasClass("goto-prevblock")) {
                            requestedPage = parseInt($paginationControlsContainer.find(".jPaginate-link-text:visible:first").text(), 10) - parameters.max_navigation_pages;
                            if (requestedPage < 0) {
                                requestedPage = 1;
                            }
                        } else if (link.hasClass("goto-nextblock")) {
                            requestedPage = parseInt($paginationControlsContainer.find(".jPaginate-link-text:visible:last").text(), 10) + 1;
                        }

                        showPage($table, requestedPage);
                    });
                }

                setupPageInput($table);

                parameters.totalPages = totalPages;

                $table.data('jpConfig', parameters);

                let requestedPage = 1;

                // If we're paginating for the first time, go to the requested page
                let pageFromData = $table.data('page');
                if (!isPaginated && typeof pageFromData !== 'undefined') {
                    requestedPage = parseInt(pageFromData, 10);
                }

                $("tbody tr", $table).hide();
                $table.data("show-all", 1);
                showPage($table, requestedPage);
            } else {
                console.log('Container is not a table');
            }
        });

        /**
         * Add a hidden input to track what page the user is currently on.
         * This allows the user's position to be remembered between page loads.
         * @param $table
         */
        function setupPageInput($table) {
            let defaultSelector = '#jpPage';
            // Check that a custom pageInput has not been set and that an input does not already exist.
            // We don't want to accidentally overwrite an existing input.
            if (typeof $table.data('pageInput') === 'undefined' && !$(defaultSelector).length) {
                $table.before('<input type="hidden" name="jpPage" id="jpPage">');
                $table.data('pageInput', defaultSelector);
            }
        }

        function showPage($table, requestedPage) {
            if (requestedPage === undefined) {
                return false;
            }

            let parameters = $table.data('jpConfig');
            let $container = getTableContainer($table);
            let $paginationControlsContainer = getPaginationControlsContainer($table);

            let currentPage = parameters.page;
            requestedPage = parseInt(requestedPage, 10);

            // Don't do anything if page is not valid
            // 0 is valid because 0 = show all.
            if (requestedPage < 0 || requestedPage > parameters.totalPages) {
                return false;
            }

            if (requestedPage === 0) {
                $("tbody tr", $table).show();
                $table.data("show-all", 0);
                $paginationControlsContainer.find('a').removeClass('current');
                $paginationControlsContainer.find('.button-show-all').addClass('current');
            } else if (currentPage != requestedPage) {
                //Get page interval to show
                let minPage, maxPage;
                if (parameters.totalPages < 10 || requestedPage < 5) {
                    minPage = 1;
                    maxPage = 10;
                } else if (requestedPage > parameters.totalPages - 5) {
                    minPage = parameters.totalPages - 9;
                    maxPage = parameters.totalPages;
                } else {
                    minPage = requestedPage - 4;
                    maxPage = requestedPage + 5;
                }
                //Hide page numbers and showing the new interval
                $paginationControlsContainer.find(".jPaginate-link-text").hide();
                for (let showPage = minPage; showPage <= maxPage; showPage++) {
                    $paginationControlsContainer.find('.jPaginate-link-text-'+showPage).show();
                    if (maxPage == parameters.totalPages) {
                        $paginationControlsContainer.find('.dots').hide();
                    } else {
                        $paginationControlsContainer.find('.dots').show();
                    }
                }

                //Making the selected page as current
                $paginationControlsContainer.find('a').removeClass('current');
                let pageToGo = $paginationControlsContainer.find('.jPaginate-link-text-'+requestedPage);
                pageToGo.addClass('current');

                //Showing rows of the selected page
                if (currentPage === 0) {
                    $("tbody tr", $table).hide();
                    $table.data("show-all", 1);
                } else {
                    $container.find('.jPaginate-row-' + currentPage).hide();
                }
                $container.find('.jPaginate-row-' + requestedPage).show();
            }

            $($table.data('pageInput')).val(requestedPage);
            parameters.page = requestedPage;

            $paginationControlsContainer.find('.goto-last').show();
            $paginationControlsContainer.find('.goto-first').removeClass('hide').show();

            if (requestedPage == 0) {
                $paginationControlsContainer.find('.prevnext').hide();
            } else {
                $paginationControlsContainer.find('.prevnext').show();
                $paginationControlsContainer.find('.button-previous').removeClass('hide');
                if (requestedPage == 1) {
                    $paginationControlsContainer.find('.button-previous').hide();
                    $paginationControlsContainer.find('.goto-first').hide();
                }
                if (requestedPage == parameters.totalPages) {
                    $paginationControlsContainer.find('.button-next').hide();
                    $paginationControlsContainer.find('.goto-last').hide();
                }
            }

            $table.data('jpConfig', parameters);

            return true;
        }

        function getTableContainer($table) {
            //We get the container (table or tbody)
            let $container = $table.find('tbody');
            if ($container.length == 0 ){
                $container = $table;
            }
            return $container;
        }

        function getPaginationControlsContainer($table) {
            let $paginationControlsContainer = $table.next(".jPaginate-page_container");
            return $paginationControlsContainer.length ? $paginationControlsContainer : null;
        }
    };
})(jQuery);
